import { useRouting } from 'expo-next-react-navigation'

// type Routes  = {
//     [key: string]: () => RouteProperty
// }

export const AuthedRoutes = {
  bookings: () =>
    ({
      routeName: 'bookings',
      web: { path: `/dashboard/bookings` },
      // native: {
      //   screen: 'bookings',
      // },
    } as const),
  artists: () =>
    ({
      routeName: 'artists',
      web: { path: `/dashboard/artists` },
    } as const),
  venues: () =>
    ({
      routeName: 'venues',
      web: { path: `/dashboard/venues` },
    } as const),
  booking: (id: string | null) =>
    id === null
      ? ({ routeName: 'booking' } as const)
      : ({
          routeName: 'booking',
          web: {
            path: `/dashboard/bookings/[id]`,
            as: `/dashboard/bookings/${id}`,
          },
          params: { id },
        } as const),
  dashboard: () =>
    ({
      routeName: 'dashboard',
    } as const),
  account: () =>
    ({
      routeName: 'account',
      web: { path: '/dashboard/account' },
    } as const),
  automatedBookings: () => ({
    routeName: 'automatedBookings',
    web: { path: '/dashboard/magic' },
  }),
  likes: () =>
    ({
      routeName: 'likes',
      web: {
        path: '/dashboard/likes',
      },
    } as const),
} as const
